import React from "react";

import Portal from "../Portal";

import styles from "./Modal.module.scss";

export interface ModalProps {
  children: React.ReactNode;
  onClose?: () => void;
  blocked?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  onClose,
  blocked = false,
  children,
}) => {
  return (
    <Portal>
      <div className={`${styles.modal} ${blocked ? styles.blocked : ""}`}>
        <div
          className={styles.backDrop}
          onClick={!blocked && onClose ? onClose : undefined}
        />
        <div className={styles.content}>{children}</div>
      </div>
    </Portal>
  );
};

export default Modal;
